/* Page to fetch all Hospital data and render the cover info 
 * Contains the HospitalTop component to which it passes the data
   for each Hospital cover */
import React, { useCallback, useEffect, useState } from "react"
import Form from "react-bootstrap/Form"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import Container from "react-bootstrap/Container"

import appStyles from "../../App.module.css"
import styles from "../../styles/PostsPage.module.css"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import NoResults from "../../assets/no-results.png"
import btnStyles from "../../styles/Button.module.css"
import { useHistory } from "react-router-dom"

import Asset from "../../components/Asset"
import { Button } from "react-bootstrap"
import TopBox from "../../components/TopBox"
import HospitalTop from "./HospitalTop"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import ImportHos from "./ImportHos"
import toast from "react-hot-toast";

const HospitalsPage = () => {
  const host = useHostName()
  const currentUser = useCurrentUser()
  // useRedirect()
  const [hospitals, setHospitals] = useState({ results: [] })
  // eslint-disable-next-line
  const [error, setErrors] = useState({})
  const [hasLoaded, setHasLoaded] = useState(false)
  const history = useHistory()
  const [query, setQuery] = useState("")
  const [showImp, setShowImp] = useState(false)

  const fetchHospitals = useCallback(
    async (searchQuery) => {
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const { data } = await axiosReq.get(
            `/masters/hospitals/?search=${searchQuery}`
          )
          setHospitals(data)
          setHasLoaded(true)
          return
        }

        const response = await axiosInstance.get(
          `${localStorage.getItem("projectSlug")}/masters/hospitals/?search=${searchQuery}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        if (response?.success === false) {
          throw response.error;
        }
        const { data } = response;
        // console.log(data)
        setHospitals(data)
        setHasLoaded(true)
      } catch (err) {
        console.log(err)
        const backendError =
          err?.response?.data?.error ||
          err?.response?.data?.detail ||
          "Failed to load hospitals.";
        toast.error(backendError);
        if (err.response?.status !== 401) {
          setErrors(err.response?.data || { detail: [backendError] })
          setHasLoaded(true)
        }
      }
    },
    [host]
  )

  useEffect(() => {
    const normalizedQuery = query.trim()
    const effectiveQuery = normalizedQuery.length >= 3 ? normalizedQuery : ""

    // Keep current UI unchanged for 1-2 chars:
    // no loader flicker and no request.
    if (normalizedQuery.length > 0 && normalizedQuery.length < 3) {
      return
    }

    setHasLoaded(false)
    const timer = setTimeout(() => {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        fetchHospitals(effectiveQuery)
      } else {
        if (localStorage.getItem("accessToken")) {
          fetchHospitals(effectiveQuery)
        }
      }
    }, 1000)

    return () => {
      clearTimeout(timer)
    }
  }, [query, host, fetchHospitals])

  return (
    <div>
      <TopBox title="Hospitals" />
      <Row className="my-2">
      <Col xs={6} >
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} py-0`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      </Col>
      <Col xs={6} >
      <Button
        className={`float-right py-0 px-2 px-md-3 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowImp((showImp) => !showImp)}
      >
        INFO
      </Button>
      </Col>
      </Row>      
      <h3 className="text-center">Hospitals</h3>
      <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/>
      {!showImp ? "" : <ImportHos />}
      {/* add Hospitals  */}
      <Row>
        <Col className="text-center">
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin") && (
              <Button
                onClick={() =>
                  history.push(
                    `/${localStorage.getItem("projectSlug")}/hospitals/create`
                  )
                }
                className={`${btnStyles.Button} ${btnStyles.Wide2} ${btnStyles.Bright}`}
              >
                Add Hospital
              </Button>
            )}
        </Col>
      </Row>
      {/* search */}
      <Row className="px-3">
        <Col className="py-2 text-center" xs={12} md={{ span: 6, offset: 3 }}>
          <Form
            className={`${styles.SearchBar} mt-3`}
            onSubmit={(event) => event.preventDefault()}
          >
            <Form.Control
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              type="text"
              className={`${styles.InputBar}`}
              placeholder="Search by Hospital Name (Minimum 3 characters are required)"
            />
          </Form>
        </Col>
      </Row>
      <Row className="h-100 px-4">
        {hasLoaded ? (
          <>
            {hospitals.results.length ? (
              hospitals.results.map((hospital) => (
                <Col
                  key={hospital.id}
                  xs={12}
                  sm={6}
                  lg={4}
                  className="py-2 px-1 px-md-3 mx-0"
                >
                  <HospitalTop
                    {...hospital}
                    onDeleteSuccess={() => {
                      setHasLoaded(false)
                      fetchHospitals(query)
                    }}
                  />
                </Col>
              ))
            ) : (
              <Container className={appStyles.Content}>
                <Asset src={NoResults} />
              </Container>
            )}
          </>
        ) : (
          <Container className={appStyles.Content}>
            <Asset spinner />
          </Container>
        )}
      </Row>
    </div>
  )
}

export default HospitalsPage
